import englishText from "./en";

const mapGermanText = {
  [englishText.MULTIPLE_PROPERTIES]: "Mehrere Eigenschaften",
  [englishText.PRICE_SMALL]: "Preis",
  [englishText.SAVE_AND_CONT]: "Save And Next",
};

export default mapGermanText;
